// @flow

import _ from 'lodash';
import { connect } from 'react-redux';

import { isSubUrlOf, isUrlBlacklisted } from '@zapier/url-utils';

import * as Account from 'app/entities/Account';
import * as Profile from 'app/entities/Profile';
import * as RouterSelectors from 'app/common/utils/RouterSelectors';
import App from 'app/team-guide/components/App';
import matchesMediaQuery from 'app/common/components/matchesMediaQuery';
import maybeRender from 'app/common/components/maybeRender';
import { TEAMS_MODAL_TRACKING_KEY } from 'app/team-guide/utils/constants';

const blacklisted = [
  '/engine/auth',
  '/sign-up',
  '/app/login',
  '/app/editor',
  '/app/contact',
  '/app/contact-us',
  '/developer/start',
];

const mapStateToProps = state => {
  const currentUrl = RouterSelectors.currentUrl(state) || '';
  const currentAccount = Account.selectors.all.currentAccount(state);
  const currentProfile = Profile.selectors.all.currentProfile(state);
  const profileId = Profile.selectors.all.currentProfileId(state);

  const isTrialingTeams = Account.selectors.isTrialingTeams(currentAccount);
  const isOnDashboardPage = isSubUrlOf(currentUrl, '/app/zaps');
  const hasViewedWelcomeModal = Profile.selectors.hasViewedHelp(
    TEAMS_MODAL_TRACKING_KEY,
    currentProfile
  );

  return {
    shouldRenderWelcomeModal:
      isOnDashboardPage && isTrialingTeams && !hasViewedWelcomeModal,
    shouldRender: isTrialingTeams && !isUrlBlacklisted(currentUrl, blacklisted),
    profileId,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onWelcomeModalClose: (profileId: string) =>
    dispatch(
      Profile.actions.acknowledgeHelp(TEAMS_MODAL_TRACKING_KEY, profileId)
    ),
});

export default _.flowRight(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  matchesMediaQuery({ wide: '(min-width: 700px)' }),
  maybeRender(props => props.shouldRender && props.matchesMediaQuery.wide)
)(App);
